<template>
  <div class="radio">
    <label :for="name">
      <div class="radio__input">
        <input
          type="radio"
          :name="name"
          :value="value"
          :required="required"
          :checked="modelValue === value || undefined"
          :disabled="disabled"
          @change="onChange"
        />
      </div>
      <div class="radio__label" @click="onClick">{{ label }}</div>
    </label>
  </div>
</template>

<script src="./radio.js"></script>
<style src="./radio.scss" lang="scss"></style>
